
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $3962eeafb7714e8d$exports = {};

$parcel$export($3962eeafb7714e8d$exports, "content", () => $3962eeafb7714e8d$export$a7db06668cad9adb);
$parcel$export($3962eeafb7714e8d$exports, "templates", () => $3962eeafb7714e8d$export$a8fc3402335b0b04);
$parcel$export($3962eeafb7714e8d$exports, "dialogs", () => $3962eeafb7714e8d$export$3cb0c1f00e640f5c);
$parcel$export($3962eeafb7714e8d$exports, "vehicleCount", () => $3962eeafb7714e8d$export$fe7bf6cedc8b5d5d);
$parcel$export($3962eeafb7714e8d$exports, "status", () => $3962eeafb7714e8d$export$471f7ae5c4103ae1);
$parcel$export($3962eeafb7714e8d$exports, "retryApi", () => $3962eeafb7714e8d$export$6a374df4b50c76a1);
$parcel$export($3962eeafb7714e8d$exports, "disclaimer", () => $3962eeafb7714e8d$export$daa7d8bf68093807);
const $3962eeafb7714e8d$export$a7db06668cad9adb = document.querySelector("main .content");
const $3962eeafb7714e8d$export$a8fc3402335b0b04 = {
    vehiclesPage: document.querySelector("template[name='vehicles-page']"),
    traction: document.querySelector("template[name='traction']"),
    model: document.querySelector("template[name='model']"),
    vehicleTag: document.querySelector("template[name='vehicle-tag']")
};
const $3962eeafb7714e8d$export$3cb0c1f00e640f5c = {
    vehicleView: {
        self: document.querySelector("dialog[name='vehicle-view']"),
        close: document.querySelector("dialog[name='vehicle-view'] .close"),
        tag: document.querySelector("dialog[name='vehicle-view'] .tag"),
        heading: document.querySelector("dialog[name='vehicle-view'] h2"),
        seznamAutobusu: document.querySelector("dialog[name='vehicle-view'] a.seznam-autobusu"),
        provoz: document.querySelector("dialog[name='vehicle-view'] a.provoz"),
        delay: document.querySelector("dialog[name='vehicle-view'] .delay label"),
        paintContainer: document.querySelector("dialog[name='vehicle-view'] .vehicle-metadata.paint"),
        paint: document.querySelector("dialog[name='vehicle-view'] .paint label"),
        path: document.querySelector("dialog[name='vehicle-view'] .path label"),
        lastStop: document.querySelector("dialog[name='vehicle-view'] .last-stop label"),
        nextStop: document.querySelector("dialog[name='vehicle-view'] .next-stop label"),
        order: document.querySelector("dialog[name='vehicle-view'] .order label"),
        shift: document.querySelector("dialog[name='vehicle-view'] .shift label"),
        connectionTableBody: document.querySelector("dialog[name='vehicle-view'] .connection tbody"),
        lastPhotoBlock: document.querySelector("dialog[name='vehicle-view'] .last-photo-block"),
        lastPhoto: document.querySelector("dialog[name='vehicle-view'] .last-photo")
    },
    faqView: {
        self: document.querySelector("dialog[name='faq-view']"),
        close: document.querySelector("dialog[name='faq-view'] .close")
    }
};
const $3962eeafb7714e8d$export$fe7bf6cedc8b5d5d = document.querySelector(".vehicle-count");
const $3962eeafb7714e8d$export$471f7ae5c4103ae1 = document.querySelector(".status");
const $3962eeafb7714e8d$export$6a374df4b50c76a1 = document.querySelector(".retry-api");
const $3962eeafb7714e8d$export$daa7d8bf68093807 = document.querySelector(".disclaimer");


var $d555c9a2b9899309$exports = {};

$parcel$export($d555c9a2b9899309$exports, "darkenedElement", () => $d555c9a2b9899309$export$13616896a1fe5aa4);
$parcel$export($d555c9a2b9899309$exports, "vehiclesPage", () => $d555c9a2b9899309$export$d30e19c453bfde76);
$parcel$export($d555c9a2b9899309$exports, "filtersEnabled", () => $d555c9a2b9899309$export$21b7c9473383dfbf);
$parcel$export($d555c9a2b9899309$exports, "addVehiclesPage", () => $d555c9a2b9899309$export$6a2a4d0cec6d9240);
$parcel$export($d555c9a2b9899309$exports, "resetDarkenedElement", () => $d555c9a2b9899309$export$5013e23b50cda560);
$parcel$export($d555c9a2b9899309$exports, "lightenElement", () => $d555c9a2b9899309$export$680dc4fd5568f2a1);
$parcel$export($d555c9a2b9899309$exports, "addVehicleView", () => $d555c9a2b9899309$export$b504c56a3924ab53);
$parcel$export($d555c9a2b9899309$exports, "updateDialogScrollLock", () => $d555c9a2b9899309$export$c47bd9218a77740c);
$parcel$export($d555c9a2b9899309$exports, "addVehicleCourse", () => $d555c9a2b9899309$export$5500365957ae9c2f);
$parcel$export($d555c9a2b9899309$exports, "addVehicleViewShift", () => $d555c9a2b9899309$export$eedbcabd984e6ba5);
$parcel$export($d555c9a2b9899309$exports, "addVehicleViewTrip", () => $d555c9a2b9899309$export$990905465269a573);
$parcel$export($d555c9a2b9899309$exports, "removeVehicleView", () => $d555c9a2b9899309$export$c1684eeccbc9b6a);
$parcel$export($d555c9a2b9899309$exports, "renderVehicles", () => $d555c9a2b9899309$export$83dd4f1338c07ef);
$parcel$export($d555c9a2b9899309$exports, "addTraction", () => $d555c9a2b9899309$export$1364cc244bf26dc2);
$parcel$export($d555c9a2b9899309$exports, "setVehicleCount", () => $d555c9a2b9899309$export$74ba305713d26789);
$parcel$export($d555c9a2b9899309$exports, "setFilterResults", () => $d555c9a2b9899309$export$7216c309925ce670);
$parcel$export($d555c9a2b9899309$exports, "deleteFilterResults", () => $d555c9a2b9899309$export$6ee65ae778f41366);
$parcel$export($d555c9a2b9899309$exports, "darkenElement", () => $d555c9a2b9899309$export$67fa4257a66f40a6);
$parcel$export($d555c9a2b9899309$exports, "clearFilters", () => $d555c9a2b9899309$export$d0e6b6bfede2a57);
$parcel$export($d555c9a2b9899309$exports, "clearFilterInputs", () => $d555c9a2b9899309$export$fd85242a0d34be40);
$parcel$export($d555c9a2b9899309$exports, "resetFilters", () => $d555c9a2b9899309$export$8da0d8f55c4b51d0);
$parcel$export($d555c9a2b9899309$exports, "disableOldPreview", () => $d555c9a2b9899309$export$7b1c1ba2de3bc7a1);
$parcel$export($d555c9a2b9899309$exports, "applyFilters", () => $d555c9a2b9899309$export$47150c42ed89d097);
$parcel$export($d555c9a2b9899309$exports, "addLoading", () => $d555c9a2b9899309$export$bb4e59d6580e437e);
$parcel$export($d555c9a2b9899309$exports, "removeLoading", () => $d555c9a2b9899309$export$219a215edaabda89);
$parcel$export($d555c9a2b9899309$exports, "setLoadingMessage", () => $d555c9a2b9899309$export$b75e26cdc67a486a);
$parcel$export($d555c9a2b9899309$exports, "setApiConnectionError", () => $d555c9a2b9899309$export$2c3512df569c6037);
$parcel$export($d555c9a2b9899309$exports, "addDisclaimer", () => $d555c9a2b9899309$export$e04572be43a4bc86);
$parcel$export($d555c9a2b9899309$exports, "removeDisclaimer", () => $d555c9a2b9899309$export$70476c33a563a15);
$parcel$export($d555c9a2b9899309$exports, "addDataAge", () => $d555c9a2b9899309$export$23f9202ae0ddf72d);
$parcel$export($d555c9a2b9899309$exports, "removeDataAge", () => $d555c9a2b9899309$export$6fdc5b6075cdcc84);
$parcel$export($d555c9a2b9899309$exports, "addFaqView", () => $d555c9a2b9899309$export$6176c55fe2aa5c1f);
$parcel$export($d555c9a2b9899309$exports, "removeFaqView", () => $d555c9a2b9899309$export$838182d13a585c4);

var $4c540910486eca1c$exports = {};

$parcel$export($4c540910486eca1c$exports, "carrierLoader", () => $4c540910486eca1c$export$350c47b152f2faf7);
$parcel$export($4c540910486eca1c$exports, "paintsLoader", () => $4c540910486eca1c$export$281a5334041c6f43);
$parcel$export($4c540910486eca1c$exports, "orderingsLoader", () => $4c540910486eca1c$export$cc182b48b6984cf7);
$parcel$export($4c540910486eca1c$exports, "vehiclesLoader", () => $4c540910486eca1c$export$274738e4cba9958f);
$parcel$export($4c540910486eca1c$exports, "carrier", () => $4c540910486eca1c$export$69611058765fa1b6);
$parcel$export($4c540910486eca1c$exports, "paints", () => $4c540910486eca1c$export$1445c00ab8035af9);
$parcel$export($4c540910486eca1c$exports, "vehicles", () => $4c540910486eca1c$export$f227cb3279b11c6);
$parcel$export($4c540910486eca1c$exports, "cachedSnapshot", () => $4c540910486eca1c$export$165323b5ea844ee2);
$parcel$export($4c540910486eca1c$exports, "fleetoraClient", () => $4c540910486eca1c$export$d7a3f6a0e4509d0c);
$parcel$export($4c540910486eca1c$exports, "loadCarrier", () => $4c540910486eca1c$export$a1d4af934ba96522);
$parcel$export($4c540910486eca1c$exports, "loadPaints", () => $4c540910486eca1c$export$8487be638f9391a0);
$parcel$export($4c540910486eca1c$exports, "loadTraffic", () => $4c540910486eca1c$export$93df199ba07efc1a);
$parcel$export($4c540910486eca1c$exports, "load", () => $4c540910486eca1c$export$11e63f7b0f3d9900);
var $c316c656b3767da8$export$b84cfc295a67a769 = /*#__PURE__*/ function(TractionType) {
    TractionType["Tram"] = "Tram";
    TractionType["Trolleybus"] = "Trolleybus";
    TractionType["Bus"] = "Bus";
    return TractionType;
}({});
var $c316c656b3767da8$export$7ed5ca4f8b987938 = /*#__PURE__*/ function(DayOfWeek) {
    DayOfWeek["Sunday"] = "Sunday";
    DayOfWeek["Monday"] = "Monday";
    DayOfWeek["Tuesday"] = "Tuesday";
    DayOfWeek["Wednesday"] = "Wednesday";
    DayOfWeek["Thursday"] = "Thursday";
    DayOfWeek["Friday"] = "Friday";
    DayOfWeek["Saturday"] = "Saturday";
    return DayOfWeek;
}({});
var $c316c656b3767da8$export$660147dd4d8478c9 = /*#__PURE__*/ function(ShiftType) {
    ShiftType["Morning"] = "Morning";
    ShiftType["FullDay"] = "FullDay";
    ShiftType["Split"] = "Split";
    ShiftType["Afternoon"] = "Afternoon";
    ShiftType["Night"] = "Night";
    return ShiftType;
}({});


const $1ad013d3babf9bd0$var$tractionHumanMap = new Map([
    [
        (0, $c316c656b3767da8$export$b84cfc295a67a769).Tram,
        "Tramvaje"
    ],
    [
        (0, $c316c656b3767da8$export$b84cfc295a67a769).Trolleybus,
        "Trolejbusy"
    ],
    [
        (0, $c316c656b3767da8$export$b84cfc295a67a769).Bus,
        "Autobusy"
    ]
]);
const $1ad013d3babf9bd0$var$idTractionMap = new Map([
    [
        1,
        (0, $c316c656b3767da8$export$b84cfc295a67a769).Tram
    ],
    [
        2,
        (0, $c316c656b3767da8$export$b84cfc295a67a769).Trolleybus
    ],
    [
        3,
        (0, $c316c656b3767da8$export$b84cfc295a67a769).Bus
    ]
]);
const $1ad013d3babf9bd0$var$tractionSAMap = new Map([
    [
        (0, $c316c656b3767da8$export$b84cfc295a67a769).Tram,
        1
    ],
    [
        (0, $c316c656b3767da8$export$b84cfc295a67a769).Trolleybus,
        3
    ],
    [
        (0, $c316c656b3767da8$export$b84cfc295a67a769).Bus,
        5
    ]
]);
function $1ad013d3babf9bd0$export$cd6dc8f677e058a1(id) {
    return Number(id.slice(1));
}
function $1ad013d3babf9bd0$export$37b8e9d5b6918a1f(id) {
    return $1ad013d3babf9bd0$export$11ab7d199b9c23c1(Number(id.charAt(0)));
}
function $1ad013d3babf9bd0$export$5f4a68cb56efb241(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $1ad013d3babf9bd0$export$11ab7d199b9c23c1(value) {
    return $1ad013d3babf9bd0$var$idTractionMap.get(value);
}
function $1ad013d3babf9bd0$export$ac118faeced66a93(type) {
    return $1ad013d3babf9bd0$var$tractionHumanMap.get(type);
}
function $1ad013d3babf9bd0$export$6fa375481234156e(type) {
    return $1ad013d3babf9bd0$var$tractionSAMap.get(type);
}
function $1ad013d3babf9bd0$export$1e3da36a069282b8(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    if (Array.isArray(obj)) return obj.map((item)=>$1ad013d3babf9bd0$export$1e3da36a069282b8(item));
    return Object.keys(obj).reduce((acc, key)=>{
        let camelKey = key.charAt(0).toLowerCase() + key.slice(1);
        acc[camelKey] = $1ad013d3babf9bd0$export$1e3da36a069282b8(obj[key]);
        return acc;
    }, {});
}
function $1ad013d3babf9bd0$export$7d78d9d5abb767a8(obj) {
    for (const innerObj of obj){
        innerObj["registrationNumber"] = $1ad013d3babf9bd0$export$cd6dc8f677e058a1(innerObj["id"]);
        innerObj["tractionType"] = $1ad013d3babf9bd0$export$37b8e9d5b6918a1f(innerObj["id"]);
    }
    return obj;
}
function $1ad013d3babf9bd0$export$bb0db16cd06af86a(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    let renameMap = {
        vehicleNumber: "id",
        delayMin: "delayMinutes"
    };
    if (Array.isArray(obj)) return obj.map((item)=>$1ad013d3babf9bd0$export$bb0db16cd06af86a(item));
    return Object.keys(obj).reduce((acc, key)=>{
        let newKey = renameMap[key] || key;
        acc[newKey] = $1ad013d3babf9bd0$export$bb0db16cd06af86a(obj[key]);
        return acc;
    }, {});
}
function $1ad013d3babf9bd0$export$9e4324320354f0bd(seconds) {
    if (seconds < 60) return [
        seconds,
        "s"
    ];
    else if (seconds < 3600) {
        let minutes = Math.floor(seconds / 60);
        return [
            minutes,
            "min."
        ];
    } else if (seconds < 86400) {
        let hours = Math.floor(seconds / 3600);
        return [
            hours,
            "hod."
        ];
    } else {
        let days = Math.floor(seconds / 86400);
        return [
            days,
            days == 1 ? "den" : days >= 2 && days <= 4 ? "dny" : "dn\u016F"
        ];
    }
}
const $1ad013d3babf9bd0$var$secondsInMinute = 60;
const $1ad013d3babf9bd0$var$secondsInHour = 60 * $1ad013d3babf9bd0$var$secondsInMinute;
const $1ad013d3babf9bd0$var$secondsInDay = 24 * $1ad013d3babf9bd0$var$secondsInHour;
const $1ad013d3babf9bd0$var$secondsInMonth = 30 * $1ad013d3babf9bd0$var$secondsInDay;
const $1ad013d3babf9bd0$var$secondsInYear = 365 * $1ad013d3babf9bd0$var$secondsInDay;
function $1ad013d3babf9bd0$export$e0d70b6b094e1f0c(seconds) {
    if (seconds >= $1ad013d3babf9bd0$var$secondsInYear) {
        const years = Math.floor(seconds / $1ad013d3babf9bd0$var$secondsInYear);
        return [
            years,
            years === 1 ? "rokem" : years >= 2 && years <= 4 ? "roky" : "lety"
        ];
    } else if (seconds >= $1ad013d3babf9bd0$var$secondsInMonth) {
        const months = Math.floor(seconds / $1ad013d3babf9bd0$var$secondsInMonth);
        return [
            months,
            months === 1 ? "m\u011Bs\xedcem" : "m\u011Bs\xedci"
        ];
    } else if (seconds >= $1ad013d3babf9bd0$var$secondsInDay) {
        const days = Math.floor(seconds / $1ad013d3babf9bd0$var$secondsInDay);
        return [
            days,
            days === 1 ? "dnem" : "dny"
        ];
    } else if (seconds >= $1ad013d3babf9bd0$var$secondsInHour) {
        const hours = Math.floor(seconds / $1ad013d3babf9bd0$var$secondsInHour);
        return [
            hours,
            hours === 1 ? "hodinou" : "hodinami"
        ];
    } else if (seconds >= $1ad013d3babf9bd0$var$secondsInMinute) {
        const minutes = Math.floor(seconds / $1ad013d3babf9bd0$var$secondsInMinute);
        return [
            minutes,
            minutes === 1 ? "minutou" : "minutami"
        ];
    }
    return [
        seconds,
        seconds === 1 ? "sekundou" : "sekundami"
    ];
}
function $1ad013d3babf9bd0$export$e347f0c01bac7bd3(day) {
    if (!day) return null;
    const normalizedDay = day.trim().toLowerCase();
    for (const dayEnumValue of Object.values((0, $c316c656b3767da8$export$7ed5ca4f8b987938))){
        if (dayEnumValue.toLowerCase() === normalizedDay) return dayEnumValue;
    }
    return null;
}
function $1ad013d3babf9bd0$export$20937d6fea16e98d(timeSpan) {
    return timeSpan.slice(0, 5);
}
function $1ad013d3babf9bd0$export$bc6475feb8a794ff(timeSpan) {
    const [hours, minutes] = timeSpan.split(":").map(Number);
    if (hours >= 24) return `${hours - 24}:${String(minutes).padStart(2, "0")}`;
    return timeSpan;
}


const $6528569ccd395439$export$66ffc91caa17bbe5 = "Server Plze\u0148 Jede je moment\xe1ln\u011B nedostupn\xfd. Jde o probl\xe9m na stran\u011B serveru, nikoliv o chybu t\xe9to str\xe1nky. Na vy\u0159e\u0161en\xed probl\xe9mu se pracuje. Zkuste to pros\xedm znovu pozd\u011Bji.";
const $6528569ccd395439$export$e5c7f2cc87983028 = "Va\u0161e za\u0159\xedzen\xed nen\xed p\u0159ipojeno k internetu. Zkontrolujte pros\xedm sv\xe9 p\u0159ipojen\xed a zkuste to znovu.";
class $6528569ccd395439$export$8270b4c6cf24f879 extends Error {
    constructor(offline, statusCode = 0){
        super(offline ? $6528569ccd395439$export$e5c7f2cc87983028 : $6528569ccd395439$export$66ffc91caa17bbe5), this.offline = offline, this.statusCode = statusCode;
        this.name = "ApiConnectionError";
    }
}
const $6528569ccd395439$export$8088424b4ac32767 = new EventTarget();
let $6528569ccd395439$export$b304ee8d8abbfba = null;
let $6528569ccd395439$var$failureRevision = 0;
function $6528569ccd395439$var$reportConnectionError(statusCode = 0) {
    const error = new $6528569ccd395439$export$8270b4c6cf24f879(navigator.onLine === false, statusCode);
    $6528569ccd395439$var$failureRevision++;
    $6528569ccd395439$export$b304ee8d8abbfba = error;
    $6528569ccd395439$export$8088424b4ac32767.dispatchEvent(new Event("change"));
    return error;
}
async function $6528569ccd395439$export$adb4bb4243526aef(input, init) {
    const revision = $6528569ccd395439$var$failureRevision;
    let response;
    try {
        response = await fetch(input, init);
    } catch (error) {
        if (init?.signal?.aborted || error instanceof Error && error.name === "AbortError") throw error;
        throw $6528569ccd395439$var$reportConnectionError();
    }
    const code = !response.ok ? await $6528569ccd395439$var$readApiErrorCode(response) : undefined;
    if (code === "BackendUnavailable" || [
        502,
        503,
        504,
        523
    ].includes(response.status) && code !== "TransitDataUnavailable") throw $6528569ccd395439$var$reportConnectionError(response.status);
    if (revision === $6528569ccd395439$var$failureRevision && $6528569ccd395439$export$b304ee8d8abbfba) {
        $6528569ccd395439$export$b304ee8d8abbfba = null;
        $6528569ccd395439$export$8088424b4ac32767.dispatchEvent(new Event("change"));
    }
    return response;
}
async function $6528569ccd395439$var$readApiErrorCode(response) {
    const contentType = response.headers.get("content-type");
    if (!contentType?.includes("application/json") && !contentType?.includes("application/problem+json")) return undefined;
    try {
        const error = await response.clone().json();
        return error && typeof error === "object" && "code" in error && typeof error.code === "string" ? error.code : undefined;
    } catch  {
        return undefined;
    }
}


const $db1d7fb253261a54$var$baseUrl = "https://fleetora-service.akac.dev";
class $db1d7fb253261a54$export$2e2bcd8739ae039 {
    constructor(apiKey){
        this.apiKey = apiKey;
    }
    async request(method, route, body = null) {
        let headers = new Headers();
        if (this.apiKey) headers.set("Authorization", this.apiKey);
        if (body) headers.set("Content-Type", "application/json; charset=utf-8");
        let path = `${$db1d7fb253261a54$var$baseUrl}/api/${route}`;
        let req = new Request(path, {
            method: method,
            body: body ? JSON.stringify(body) : null,
            headers: headers,
            credentials: this.apiKey ? "include" : "omit"
        });
        return await (0, $6528569ccd395439$export$adb4bb4243526aef)(req);
    }
    async getTraffic() {
        let res = await this.request("GET", "provoz");
        if (!res.ok) throw `Failed to fetch cached traffic: ${res.status} => ${await res.text()}`;
        let data = (0, $1ad013d3babf9bd0$export$7d78d9d5abb767a8)((0, $1ad013d3babf9bd0$export$bb0db16cd06af86a)((0, $1ad013d3babf9bd0$export$1e3da36a069282b8)(await res.json())));
        let snapshot = {
            age: Number(res.headers.get("Age")),
            date: new Date(res.headers.get("Date")),
            dayOfWeek: (0, $1ad013d3babf9bd0$export$e347f0c01bac7bd3)(res.headers.get("Day-Of-Week")),
            isOld: false,
            vehicles: data
        };
        return snapshot;
    }
    async getTrip(tripId) {
        let res = await this.request("POST", `gtfs/trip`, tripId);
        if (!res.ok) throw `Failed to fetch trip ${tripId}: ${res.status} => ${await res.text()}`;
        return (0, $1ad013d3babf9bd0$export$1e3da36a069282b8)(await res.json());
    }
    async getCourse(vehicleId) {
        let res = await this.request("POST", `provoz/course`, vehicleId);
        if (!res.ok) throw `Failed to fetch order of ${vehicleId}: ${res.status} => ${await res.text()}`;
        return (0, $1ad013d3babf9bd0$export$1e3da36a069282b8)(await res.json());
    }
    async getShift(vehicleId) {
        let res = await this.request("POST", `provoz/shift`, vehicleId);
        if (!res.ok) throw `Failed to fetch order of ${vehicleId}: ${res.status} => ${await res.text()}`;
        return (0, $1ad013d3babf9bd0$export$1e3da36a069282b8)(await res.json());
    }
    async getPhotoMeta(documentationId) {
        let res = await this.request("POST", "image/meta", documentationId);
        if (!res.ok) throw `Failed to fetch photo meta for ${documentationId}: ${res.status} => ${await res.text()}`;
        return await res.json();
    }
    async getCarrier() {
        let res = await this.request("GET", "seznam-autobusu/carrier");
        if (!res.ok) throw `Failed to fetch carrier: ${res.status} => ${await res.text()}`;
        return await res.json();
    }
    async getPaints() {
        let res = await this.request("GET", "seznam-autobusu/paint-vehicles");
        if (!res.ok) throw `Failed to fetch paints: ${res.status} => ${await res.text()}`;
        return await res.json();
    }
}


let $4c540910486eca1c$export$350c47b152f2faf7;
let $4c540910486eca1c$export$281a5334041c6f43;
let $4c540910486eca1c$export$cc182b48b6984cf7;
let $4c540910486eca1c$export$274738e4cba9958f;
let $4c540910486eca1c$export$69611058765fa1b6;
let $4c540910486eca1c$export$1445c00ab8035af9;
let $4c540910486eca1c$export$f227cb3279b11c6;
let $4c540910486eca1c$export$165323b5ea844ee2;
let $4c540910486eca1c$export$d7a3f6a0e4509d0c = new (0, $db1d7fb253261a54$export$2e2bcd8739ae039)();
async function $4c540910486eca1c$export$a1d4af934ba96522() {
    $4c540910486eca1c$export$69611058765fa1b6 = await $4c540910486eca1c$export$d7a3f6a0e4509d0c.getCarrier();
}
async function $4c540910486eca1c$export$8487be638f9391a0() {
    $4c540910486eca1c$export$1445c00ab8035af9 = await $4c540910486eca1c$export$d7a3f6a0e4509d0c.getPaints();
}
async function $4c540910486eca1c$export$93df199ba07efc1a() {
    try {
        $4c540910486eca1c$export$165323b5ea844ee2 = await $4c540910486eca1c$export$d7a3f6a0e4509d0c.getTraffic();
        $4c540910486eca1c$export$f227cb3279b11c6 = $4c540910486eca1c$export$165323b5ea844ee2.vehicles;
    } catch (err) {
        console.error("Failed to request through Fleetora, trying SignalR", err);
        throw err;
    }
}
async function $4c540910486eca1c$export$11e63f7b0f3d9900() {
    $4c540910486eca1c$export$350c47b152f2faf7 = $4c540910486eca1c$export$a1d4af934ba96522();
    $4c540910486eca1c$export$281a5334041c6f43 = $4c540910486eca1c$export$8487be638f9391a0();
    $4c540910486eca1c$export$274738e4cba9958f = $4c540910486eca1c$export$93df199ba07efc1a();
    await Promise.all([
        $4c540910486eca1c$export$350c47b152f2faf7,
        $4c540910486eca1c$export$281a5334041c6f43,
        $4c540910486eca1c$export$274738e4cba9958f
    ]);
}



var $832aea034a1a7998$exports = {};

$parcel$export($832aea034a1a7998$exports, "resetFiltersClicked", () => $832aea034a1a7998$export$cb5fe47fceba7397);
$parcel$export($832aea034a1a7998$exports, "filterInputsChanged", () => $832aea034a1a7998$export$deeab6c109b1c6e3);
$parcel$export($832aea034a1a7998$exports, "vehicleDialogOpened", () => $832aea034a1a7998$export$286da751aa569f44);



$3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.close.onclick = async ()=>{
    $d555c9a2b9899309$export$c1684eeccbc9b6a();
};
$3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.self.onclose = async ()=>{
    $d555c9a2b9899309$export$5013e23b50cda560();
};
$3962eeafb7714e8d$export$3cb0c1f00e640f5c.faqView.close.onclick = async ()=>{
    $d555c9a2b9899309$export$838182d13a585c4();
};
$3962eeafb7714e8d$export$3cb0c1f00e640f5c.faqView.self.onclose = async ()=>{
    $d555c9a2b9899309$export$5013e23b50cda560();
};
async function $832aea034a1a7998$export$cb5fe47fceba7397() {
    $d555c9a2b9899309$export$d0e6b6bfede2a57();
}
async function $832aea034a1a7998$export$deeab6c109b1c6e3() {
    $d555c9a2b9899309$export$47150c42ed89d097();
}
async function $832aea034a1a7998$export$286da751aa569f44(vehicle) {
    console.info("[Vehicle] Dialog opened");
    // Skip loading additional data for imported vehicles
    if (vehicle.isImported) {
        console.info("[Vehicle] Skipping additional data loading for imported vehicle");
        return;
    }
    // Skip if no connectionId is available
    if (!vehicle.connectionId) {
        console.info("[Vehicle] No connectionId available, skipping trip data loading");
        return;
    }
    const tripId = Math.abs(vehicle.connectionId);
    let coursePromise = $4c540910486eca1c$export$d7a3f6a0e4509d0c.getCourse(vehicle.id);
    let shiftPromise = $4c540910486eca1c$export$d7a3f6a0e4509d0c.getShift(vehicle.id);
    let tripPromise = $4c540910486eca1c$export$d7a3f6a0e4509d0c.getTrip(tripId);
    let course = null;
    let shift = null;
    try {
        course = await coursePromise;
    } catch (err) {
        console.error("[Vehicle] Failed to load order", err);
    }
    try {
        shift = await shiftPromise;
    } catch (err) {
        console.error("[Vehicle] Failed to load shift", err);
    }
    $d555c9a2b9899309$export$5500365957ae9c2f(course, shift);
    $d555c9a2b9899309$export$eedbcabd984e6ba5(shift);
    try {
        let trip = await tripPromise;
        $d555c9a2b9899309$export$990905465269a573(vehicle.lastStopName, trip);
    } catch (err) {
        $d555c9a2b9899309$export$990905465269a573(vehicle.lastStopName, null);
        console.error("[Vehicle] Failed to load trip", err);
    }
}
let $832aea034a1a7998$var$dialogs = Array.from(document.querySelectorAll("dialog"));
for (let dialog of $832aea034a1a7998$var$dialogs){
    dialog.onclick = async (evt)=>{
        let element = evt.target;
        if (element.nodeName == "DIALOG") element.close();
    };
    dialog.addEventListener("close", ()=>{
        $d555c9a2b9899309$export$c47bd9218a77740c();
    });
}




const $7ac401039e1e8f3f$export$344eed93c2ece13a = "https://image-cache.akac.workers.dev";
const $7ac401039e1e8f3f$export$6069652cea829d46 = /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/;




const $c7ac6f7d2adc3c5f$var$photoAspectRatio = 142 / 225;
const $c7ac6f7d2adc3c5f$var$secondsInDay = 86400;
let $c7ac6f7d2adc3c5f$var$pendingFrame = null;
function $c7ac6f7d2adc3c5f$export$b0ec36ff8abd0740(documentationId, width, quality) {
    return `${0, $7ac401039e1e8f3f$export$344eed93c2ece13a}/?documentationId=${documentationId}&width=${width}&quality=${quality}`;
}
function $c7ac6f7d2adc3c5f$export$3d73b3b0afaba620(block, container, vehicle) {
    if ($c7ac6f7d2adc3c5f$var$pendingFrame !== null) {
        cancelAnimationFrame($c7ac6f7d2adc3c5f$var$pendingFrame);
        $c7ac6f7d2adc3c5f$var$pendingFrame = null;
    }
    if (!vehicle.lastPhotoId) {
        block.classList.add("invisible");
        container.replaceChildren();
        return;
    }
    block.classList.remove("invisible");
    const documentationId = vehicle.lastPhotoId;
    const alt = `Fotografie vozu ${vehicle.registrationNumber}`;
    const render = ()=>{
        const width = Math.floor(container.getBoundingClientRect().width);
        if (width <= 0) {
            $c7ac6f7d2adc3c5f$var$pendingFrame = requestAnimationFrame(render);
            return;
        }
        $c7ac6f7d2adc3c5f$var$pendingFrame = null;
        $c7ac6f7d2adc3c5f$var$buildPhoto(container, documentationId, alt, width);
    };
    $c7ac6f7d2adc3c5f$var$pendingFrame = requestAnimationFrame(render);
}
function $c7ac6f7d2adc3c5f$var$buildPhoto(container, documentationId, alt, width) {
    const height = Math.round(width * $c7ac6f7d2adc3c5f$var$photoAspectRatio);
    const wrapper = document.createElement("div");
    wrapper.className = "image-wrapper";
    const link = document.createElement("a");
    link.className = "image-container";
    link.href = `https://seznam-autobusu.cz/dokumentacka/${documentationId}`;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    const placeholder = document.createElement("div");
    placeholder.className = "image-loading-placeholder";
    placeholder.style.width = `${width}px`;
    placeholder.style.height = `${height}px`;
    for (const position of [
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
    ]){
        const corner = document.createElement("div");
        corner.className = `corner ${position}`;
        placeholder.append(corner);
    }
    const altText = document.createElement("div");
    altText.className = "loading-alt-text";
    altText.textContent = alt;
    placeholder.append(altText);
    const image = document.createElement("img");
    image.alt = alt;
    image.width = width;
    image.height = height;
    image.className = "loading";
    link.append(placeholder, image);
    wrapper.append(link);
    image.onload = ()=>{
        placeholder.remove();
        image.classList.remove("loading");
    };
    image.onerror = ()=>{
        const error = document.createElement("div");
        error.className = "last-photo-error";
        error.textContent = "Nelze na\u010D\xedst obr\xe1zek";
        container.replaceChildren(error);
    };
    container.replaceChildren(wrapper);
    image.src = $c7ac6f7d2adc3c5f$export$b0ec36ff8abd0740(documentationId, Math.round(width * Math.min(window.devicePixelRatio, 3)), 80);
    $c7ac6f7d2adc3c5f$var$loadPhotoMeta(wrapper, documentationId);
}
async function $c7ac6f7d2adc3c5f$var$loadPhotoMeta(wrapper, documentationId) {
    try {
        const meta = await $4c540910486eca1c$export$d7a3f6a0e4509d0c.getPhotoMeta(documentationId.toString());
        const metaElement = document.createElement("div");
        metaElement.className = "meta";
        if (meta.age) {
            const [value, unit] = (0, $1ad013d3babf9bd0$export$e0d70b6b094e1f0c)(meta.age * $c7ac6f7d2adc3c5f$var$secondsInDay);
            const date = document.createElement("span");
            date.className = "date";
            date.textContent = `P\u{159}ed ${value} ${unit}`;
            metaElement.append(date);
        }
        if (meta.author) {
            const copyright = document.createElement("span");
            copyright.className = "copyright";
            copyright.textContent = `\xa9 ${meta.author}`;
            metaElement.append(copyright);
        }
        if (metaElement.childElementCount > 0) wrapper.append(metaElement);
    } catch (err) {
        console.error("[Photo] Failed to load photo meta", err);
    }
}


let $d555c9a2b9899309$export$13616896a1fe5aa4;
let $d555c9a2b9899309$export$d30e19c453bfde76;
let $d555c9a2b9899309$export$21b7c9473383dfbf;
function $d555c9a2b9899309$export$6a2a4d0cec6d9240(acPercentage, averageDelay) {
    $d555c9a2b9899309$export$d30e19c453bfde76 = $3962eeafb7714e8d$export$a8fc3402335b0b04.vehiclesPage.content.cloneNode(true).firstElementChild;
    $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".reset-filters").onclick = async ()=>await $832aea034a1a7998$export$cb5fe47fceba7397();
    $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".buttons .faq").onclick = async ()=>$d555c9a2b9899309$export$6176c55fe2aa5c1f();
    Array.from($d555c9a2b9899309$export$d30e19c453bfde76.querySelectorAll(".filter input")).forEach(async (input)=>{
        input.oninput = async ()=>await $832aea034a1a7998$export$deeab6c109b1c6e3();
    });
    $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".ac-percentage").textContent = acPercentage.toString();
    $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".average-delay").textContent = averageDelay.toString();
    if ($4c540910486eca1c$export$165323b5ea844ee2) {
        let parts = (0, $1ad013d3babf9bd0$export$9e4324320354f0bd)($4c540910486eca1c$export$165323b5ea844ee2.age);
        $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".data-age").textContent = parts[0].toString();
        $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".data-age-unit").textContent = parts[1];
        $d555c9a2b9899309$export$23f9202ae0ddf72d();
    }
    $3962eeafb7714e8d$export$a7db06668cad9adb.append($d555c9a2b9899309$export$d30e19c453bfde76);
}
function $d555c9a2b9899309$export$5013e23b50cda560() {
    if (!$d555c9a2b9899309$export$13616896a1fe5aa4) return;
    $d555c9a2b9899309$export$680dc4fd5568f2a1($d555c9a2b9899309$export$13616896a1fe5aa4);
    $d555c9a2b9899309$export$13616896a1fe5aa4 = null;
}
function $d555c9a2b9899309$export$b504c56a3924ab53(line, heading, seznamAutobusu, provoz, delay, paint, from, to, lastStop, nextStop, vehicle) {
    $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.tag.textContent = line;
    $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.heading.textContent = heading;
    $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.seznamAutobusu.href = seznamAutobusu;
    // Handle imported vehicles that might not have connectionId
    if (vehicle?.isImported && !vehicle.connectionId) {
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.provoz.href = "";
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.provoz.style.pointerEvents = "none";
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.provoz.style.opacity = "0.5";
    } else {
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.provoz.href = provoz;
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.provoz.style.pointerEvents = "auto";
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.provoz.style.opacity = "1";
    }
    if (delay == 0) $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.delay.innerHTML = `<span class="safety">Spoj jede v\u{10D}as</span>`;
    else $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.delay.innerHTML = `+ <span class="danger"><b>${delay}</b> min.</span>`;
    if (paint) {
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.paintContainer.classList.remove("invisible");
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.paint.textContent = paint;
    } else {
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.paintContainer.classList.add("invisible");
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.paint.textContent = "";
    }
    // Handle imported vehicles differently
    if (vehicle?.isImported) {
        // Hide path, last/next stop information
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.path.textContent = "";
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.lastStop.textContent = "";
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.nextStop.textContent = "";
        // Show imported vehicle notice instead of loading course/shift/connection info
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.order.innerHTML = `<div class="imported-vehicle-notice">Detail vozidla je nedostupn\xfd kv\u{16F}li technick\xe9 limitaci na stran\u{11B} DP.</div>`;
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.shift.innerHTML = "";
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.connectionTableBody.innerHTML = "";
        while($3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.connectionTableBody.firstElementChild)$3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.connectionTableBody.firstElementChild.remove();
    } else {
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.path.textContent = `${from} > ${to}`;
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.lastStop.textContent = lastStop;
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.nextStop.textContent = nextStop ?? lastStop;
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.order.innerHTML = `Na\u{10D}\xedt\xe1n\xed`;
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.shift.innerHTML = `Na\u{10D}\xedt\xe1n\xed`;
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.connectionTableBody.innerHTML = "Na\u010D\xedt\xe1n\xed";
        while($3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.connectionTableBody.firstElementChild)$3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.connectionTableBody.firstElementChild.remove();
    }
    $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.self.showModal();
    $d555c9a2b9899309$export$c47bd9218a77740c();
    if (vehicle) (0, $c7ac6f7d2adc3c5f$export$3d73b3b0afaba620)($3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.lastPhotoBlock, $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.lastPhoto, vehicle);
    else {
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.lastPhotoBlock.classList.add("invisible");
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.lastPhoto.replaceChildren();
    }
    $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.seznamAutobusu.blur();
}
function $d555c9a2b9899309$var$getShiftTypeLabel(type) {
    switch(type){
        case (0, $c316c656b3767da8$export$660147dd4d8478c9).Morning:
            return "rann\xed";
        case (0, $c316c656b3767da8$export$660147dd4d8478c9).FullDay:
            return "t\xfara";
        case (0, $c316c656b3767da8$export$660147dd4d8478c9).Split:
            return "\u0161ejdr";
        case (0, $c316c656b3767da8$export$660147dd4d8478c9).Afternoon:
            return "odpoledn\xed";
        case (0, $c316c656b3767da8$export$660147dd4d8478c9).Night:
            return "no\u010Dn\xed";
    }
}
function $d555c9a2b9899309$export$5500365957ae9c2f(course, shift) {
    if (!course) {
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.order.innerHTML = `Chyba p\u{159}i na\u{10D}\xedt\xe1n\xed`;
        return;
    }
    let shiftType = shift ? ` (${$d555c9a2b9899309$var$getShiftTypeLabel(shift.type)})` : "";
    $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.order.innerHTML = `Kurz: <code>${course.originalLine}/${course.order}</code>${shiftType}`;
}
function $d555c9a2b9899309$export$eedbcabd984e6ba5(shift) {
    if (!shift) {
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.shift.innerHTML = `Chyba p\u{159}i na\u{10D}\xedt\xe1n\xed`;
        return;
    }
    $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.shift.innerHTML = `Z\xe1tah: <code>${(0, $1ad013d3babf9bd0$export$20937d6fea16e98d)(shift.endsAt)}</code>`;
}
function $d555c9a2b9899309$export$990905465269a573(lastStopName, trip) {
    if (!trip) {
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.connectionTableBody.innerHTML = `Chyba p\u{159}i na\u{10D}\xedt\xe1n\xed`;
        return;
    } else $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.connectionTableBody.innerHTML = "";
    for (let departure of trip.departures){
        let stopNameElement = document.createElement("td");
        stopNameElement.textContent = `${departure.stopName}${departure.isOnRequest ? " (Z)" : ""}`;
        let stopDepartureElement = document.createElement("td");
        stopDepartureElement.innerHTML = `<code>${(0, $1ad013d3babf9bd0$export$bc6475feb8a794ff)((0, $1ad013d3babf9bd0$export$20937d6fea16e98d)(departure.departuresAt))}</code>`;
        let tableRowElement = document.createElement("tr");
        if (departure.stopName == lastStopName) tableRowElement.classList.add("highlighted-stop");
        tableRowElement.appendChild(stopNameElement);
        tableRowElement.appendChild(stopDepartureElement);
        $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.connectionTableBody.appendChild(tableRowElement);
    }
}
function $d555c9a2b9899309$export$c1684eeccbc9b6a() {
    $3962eeafb7714e8d$export$3cb0c1f00e640f5c.vehicleView.self.close();
}
function $d555c9a2b9899309$export$83dd4f1338c07ef(vehicles) {
    let vehiclesView = $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".vehicles-view");
    vehiclesView.replaceChildren();
    for (let tractionType of Object.values((0, $c316c656b3767da8$export$b84cfc295a67a769))){
        let modelsOfTraction = $4c540910486eca1c$export$69611058765fa1b6.filter((x)=>x.tractionType === tractionType);
        let vehiclesOfTraction = vehicles.filter((x)=>x.tractionType == tractionType);
        $d555c9a2b9899309$export$1364cc244bf26dc2(tractionType, modelsOfTraction, vehiclesOfTraction);
    }
}
function $d555c9a2b9899309$export$1364cc244bf26dc2(type, models, vehicles) {
    console.info(`Adding traction for ${type} with ${models.length} models and ${vehicles.length} vehicles`);
    let tractionClone = $3962eeafb7714e8d$export$a8fc3402335b0b04.traction.content.cloneNode(true).firstElementChild;
    tractionClone.querySelector(".icon").src = `./assets/${(0, $c316c656b3767da8$export$b84cfc295a67a769)[type].toString().toLowerCase()}.svg`;
    tractionClone.querySelector(".title").textContent = `${(0, $1ad013d3babf9bd0$export$ac118faeced66a93)(type)} (${vehicles.length})`;
    let modelsDiv = tractionClone.querySelector(".models");
    let results = [];
    for (let model of models){
        let vehiclesOfModel = vehicles.filter((x)=>model.registrationNumbers.includes(x.registrationNumber));
        if (vehiclesOfModel.length == 0) continue;
        vehiclesOfModel = vehiclesOfModel.sort((a, b)=>{
            return a.registrationNumber - b.registrationNumber;
        });
        results.push({
            model: model,
            vehicles: vehiclesOfModel
        });
    }
    results = results.sort((a, b)=>{
        return b.vehicles.length - a.vehicles.length;
    });
    let unassigned = vehicles.filter((original)=>!results.some((result)=>result.vehicles.some((vehicle)=>vehicle.registrationNumber == original.registrationNumber)));
    if (unassigned && unassigned.length > 0) console.info(`Unassigned for traction type ${type}`, unassigned);
    let unusual = vehicles.filter((original)=>{
        let vehicleType = (0, $1ad013d3babf9bd0$export$11ab7d199b9c23c1)(Number(original.id.substring(0, 1)));
        let tractionType = original.lineMeta.tractionType;
        return vehicleType != tractionType;
    });
    if (unusual && unusual.length > 0) console.info(`Unusual assign for traction type ${type}`, unusual);
    for (let pair of results){
        console.info(`Model ${pair.model.name} has ${pair.vehicles.length} vehicles on track`);
        let modelClone = $3962eeafb7714e8d$export$a8fc3402335b0b04.model.content.cloneNode(true).firstElementChild;
        modelClone.querySelector(".name").textContent = `${pair.model.name} (${pair.vehicles.length})`;
        let vehicleTags = modelClone.querySelector(".vehicle-tags");
        for (let vehicle of pair.vehicles){
            let tractionType = (0, $1ad013d3babf9bd0$export$11ab7d199b9c23c1)(Number(vehicle.id[0]));
            let vehicleTagClone = $3962eeafb7714e8d$export$a8fc3402335b0b04.vehicleTag.content.cloneNode(true).firstElementChild;
            vehicleTagClone.dataset.line = vehicle.lineMeta.name;
            vehicleTagClone.dataset.registrationNumber = vehicle.registrationNumber.toString();
            vehicleTagClone.querySelector(".value").textContent = vehicle.registrationNumber.toString();
            let paint = $4c540910486eca1c$export$1445c00ab8035af9.find((x)=>x.vehicleId === vehicle.id);
            if (paint) vehicleTagClone.classList.add("paint", paint.paintId);
            vehicleTagClone.onclick = async ()=>{
                $d555c9a2b9899309$export$67fa4257a66f40a6(vehicleTagClone);
                $d555c9a2b9899309$export$b504c56a3924ab53(vehicle.lineMeta.name, pair.model.name, `https://seznam-autobusu.cz/seznam?evc=${vehicle.registrationNumber}&tractionId=${(0, $1ad013d3babf9bd0$export$6fa375481234156e)(tractionType)}&iddopravce=71`, vehicle.connectionId ? `https://jizdnirady.pmdp.cz/provoz/?id=${vehicle.connectionId}` : "", vehicle.delayMinutes, paint?.name, vehicle.startName || "", vehicle.destinationName || "", vehicle.lastStopName || "", vehicle.nextStopName, vehicle);
                $832aea034a1a7998$export$286da751aa569f44(vehicle);
            };
            vehicleTags.append(vehicleTagClone);
        }
        modelsDiv.append(modelClone);
    }
    $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".vehicles-view").append(tractionClone);
}
function $d555c9a2b9899309$export$74ba305713d26789(value) {
    $3962eeafb7714e8d$export$fe7bf6cedc8b5d5d.textContent = ` (${value})`;
}
function $d555c9a2b9899309$export$7216c309925ce670(value) {
    $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".filter-results").textContent = ` (${value})`;
}
function $d555c9a2b9899309$export$6ee65ae778f41366() {
    $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".filter-results").textContent = "";
}
function $d555c9a2b9899309$export$67fa4257a66f40a6(element) {
    element.classList.add("dark");
    $d555c9a2b9899309$export$13616896a1fe5aa4 = element;
}
function $d555c9a2b9899309$export$680dc4fd5568f2a1(element) {
    element.classList.remove("dark");
}
function $d555c9a2b9899309$export$d0e6b6bfede2a57() {
    if ($d555c9a2b9899309$export$21b7c9473383dfbf) {
        $d555c9a2b9899309$export$fd85242a0d34be40();
        $d555c9a2b9899309$export$8da0d8f55c4b51d0();
        $d555c9a2b9899309$export$21b7c9473383dfbf = false;
    } else if (!$d555c9a2b9899309$export$21b7c9473383dfbf && $4c540910486eca1c$export$165323b5ea844ee2.isOld) $d555c9a2b9899309$export$7b1c1ba2de3bc7a1();
}
function $d555c9a2b9899309$export$fd85242a0d34be40() {
    let inputs = $d555c9a2b9899309$export$d30e19c453bfde76.querySelectorAll(".filter input");
    for (let input of Array.from(inputs))input.value = "";
}
function $d555c9a2b9899309$export$47150c42ed89d097() {
    $d555c9a2b9899309$export$21b7c9473383dfbf = true;
    let line = $d555c9a2b9899309$export$d30e19c453bfde76.querySelector("input[name='line-filter']").value.trim();
    let course = $d555c9a2b9899309$export$d30e19c453bfde76.querySelector("input[name='course-filter']").value.trim();
    if (line == "" && course == "") {
        $d555c9a2b9899309$export$8da0d8f55c4b51d0();
        return;
    }
    let filtered = $4c540910486eca1c$export$f227cb3279b11c6;
    if (line != "") filtered = filtered.filter((x)=>x.lineMeta.name == line);
    if (course != "") filtered = filtered.filter((x)=>x.order != null && x.order.toString() == course);
    $d555c9a2b9899309$export$83dd4f1338c07ef(filtered);
    $d555c9a2b9899309$export$7216c309925ce670(filtered.length);
}
function $d555c9a2b9899309$export$8da0d8f55c4b51d0() {
    $d555c9a2b9899309$export$6ee65ae778f41366();
    $d555c9a2b9899309$export$83dd4f1338c07ef($4c540910486eca1c$export$f227cb3279b11c6);
}
function $d555c9a2b9899309$export$7b1c1ba2de3bc7a1() {
    let url = new URL(window.location.href);
    url.search = "";
    window.location.href = url.toString();
}
function $d555c9a2b9899309$export$bb4e59d6580e437e() {
    $3962eeafb7714e8d$export$471f7ae5c4103ae1.classList.remove("invisible");
}
function $d555c9a2b9899309$export$219a215edaabda89() {
    $3962eeafb7714e8d$export$471f7ae5c4103ae1.classList.add("invisible");
}
function $d555c9a2b9899309$export$b75e26cdc67a486a(msg) {
    $3962eeafb7714e8d$export$471f7ae5c4103ae1.textContent = msg;
}
function $d555c9a2b9899309$export$2c3512df569c6037(error) {
    $3962eeafb7714e8d$export$6a374df4b50c76a1.classList.toggle("invisible", !error);
    if (error) {
        $d555c9a2b9899309$export$b75e26cdc67a486a(`\u{274C} ${error.message}`);
        $d555c9a2b9899309$export$bb4e59d6580e437e();
    } else $d555c9a2b9899309$export$219a215edaabda89();
}
function $d555c9a2b9899309$export$e04572be43a4bc86() {
    $3962eeafb7714e8d$export$daa7d8bf68093807.classList.remove("invisible");
}
function $d555c9a2b9899309$export$70476c33a563a15() {
    $3962eeafb7714e8d$export$daa7d8bf68093807.classList.add("invisible");
}
function $d555c9a2b9899309$export$23f9202ae0ddf72d() {
    $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".data-age-container").classList.remove("invisible");
}
function $d555c9a2b9899309$export$6fdc5b6075cdcc84() {
    $d555c9a2b9899309$export$d30e19c453bfde76.querySelector(".data-age-container").classList.add("invisible");
}
function $d555c9a2b9899309$export$6176c55fe2aa5c1f() {
    $d555c9a2b9899309$export$67fa4257a66f40a6(document.querySelector(".buttons .faq"));
    $3962eeafb7714e8d$export$3cb0c1f00e640f5c.faqView.self.showModal();
    $d555c9a2b9899309$export$c47bd9218a77740c();
}
function $d555c9a2b9899309$export$838182d13a585c4() {
    $3962eeafb7714e8d$export$3cb0c1f00e640f5c.faqView.self.close();
}
function $d555c9a2b9899309$export$c47bd9218a77740c() {
    const anyDialogOpen = Array.from(document.querySelectorAll("dialog")).some((dialog)=>dialog.open);
    document.body.classList.toggle("dialog-open", anyDialogOpen);
}






async function $ca7ecf4cc26970aa$var$main() {
    $d555c9a2b9899309$exports.addLoading();
    try {
        await $4c540910486eca1c$exports.load();
        if ($4c540910486eca1c$exports.cachedSnapshot) console.info(`Cached snapshot is ${$4c540910486eca1c$exports.cachedSnapshot.age} seconds old, day of week is ${(0, $c316c656b3767da8$export$7ed5ca4f8b987938)[$4c540910486eca1c$exports.cachedSnapshot.dayOfWeek]}`);
    } catch (err) {
        console.error("Failed to load data", err);
        $d555c9a2b9899309$exports.setLoadingMessage(err instanceof (0, $6528569ccd395439$export$8270b4c6cf24f879) ? `\u{274C} ${err.message}` : "\u274C Selhalo na\u010D\xedt\xe1n\xed dat, zkus to znovu pozd\u011Bji");
        return;
    }
    $d555c9a2b9899309$exports.removeLoading();
    let acVehicles = $4c540910486eca1c$exports.vehicles.filter((x)=>x.isAirConditioned);
    let trackVehicles = $4c540910486eca1c$exports.vehicles.filter((x)=>x.nextStopName);
    let delayedVehicles = trackVehicles.filter((x)=>x.delayMinutes);
    let totalDelay = delayedVehicles.map((x)=>x.delayMinutes).reduce((result, a)=>result + a, 0) * 60;
    let acPercentage = $4c540910486eca1c$exports.vehicles.length ? Math.round(acVehicles.length / $4c540910486eca1c$exports.vehicles.length * 100) : 0;
    let averageDelay = trackVehicles.length ? Math.round(totalDelay / trackVehicles.length) : 0;
    $d555c9a2b9899309$exports.addVehiclesPage(acPercentage, averageDelay);
    $d555c9a2b9899309$exports.setVehicleCount($4c540910486eca1c$exports.vehicles.length);
    $d555c9a2b9899309$exports.renderVehicles($4c540910486eca1c$exports.vehicles);
    $d555c9a2b9899309$exports.addDisclaimer();
}
function $ca7ecf4cc26970aa$var$registerGlobals() {
    window.fleetoraClient = $4c540910486eca1c$exports.fleetoraClient;
    window.Dom = $3962eeafb7714e8d$exports;
    window.Display = $d555c9a2b9899309$exports;
    window.Events = $832aea034a1a7998$exports;
    window.Data = $4c540910486eca1c$exports;
}
function $ca7ecf4cc26970aa$var$handleApiAvailabilityChange() {
    $d555c9a2b9899309$exports.setApiConnectionError((0, $6528569ccd395439$export$b304ee8d8abbfba));
}
function $ca7ecf4cc26970aa$var$handleRetry() {
    window.location.reload();
}
(0, $6528569ccd395439$export$8088424b4ac32767).addEventListener("change", $ca7ecf4cc26970aa$var$handleApiAvailabilityChange);
$3962eeafb7714e8d$exports.retryApi.onclick = $ca7ecf4cc26970aa$var$handleRetry;
$ca7ecf4cc26970aa$var$registerGlobals();
$ca7ecf4cc26970aa$var$main();


//# sourceMappingURL=repo.0e6c2cbb.js.map
